<template>
    <footer class="footer">
        <div class="footer-content">
            <p class="copyright">
                &copy; 2011-{{ currentYear }} {{ t('footer.companyName') }}
            </p>

            <!-- ✨ 仅当当前语言为中文 ('zh') 时才渲染备案信息 -->
            <div v-if="isChinese" class="beian-info">
                <!-- 工信部 ICP 备案 -->
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                    粤ICP备17037440号-1
                </a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

// 获取翻译函数 t 和当前语言 locale
const { t, locale } = useI18n()

// 获取当前年份
const currentYear = new Date().getFullYear()

// 计算属性：判断当前是否为中文环境
// 注意：如果你的中文标识符不是 'zh'（比如 'zh-CN'），请根据实际情况修改
const isChinese = computed(() => locale.value === 'zh')
</script>

<style lang="css" scoped>
/* =========================================
   底部 Footer 备案信息样式 (保持不变)
========================================= */
.footer {
    background-color: #1a1a1a;
    color: #888;
    padding: 40px 20px;
    text-align: center;
    font-size: 0.85rem;
    margin-top: 60px;
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.copyright {
    margin: 0;
    color: #a3a3a3;
}

.beian-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 15px;
}

.beian-info a {
    color: #888;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: color 0.3s ease;
}

.beian-info a:hover {
    color: #ffffff;
}

.beian-info .divider {
    color: #444;
    font-size: 0.8rem;
}

.police-beian img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
}

@media (max-width: 600px) {
    .beian-info {
        flex-direction: column;
        gap: 10px;
    }

    .beian-info .divider {
        display: none;
    }
}
</style>